import {AgentSchema} from '../../agent';
import {MarketSchema} from '../../market';
import {TestListSchema} from '../../testLists';
import {TestListName} from '../../validation';
import {ObjectIdSchema} from '../../zod';
import {WithIdSchema, ApiDefinition} from '../definitions';
import {z} from 'zod';

export const MaxTestLists = 50;
export const MaxTestListAccounts = 12_000;

export const GetTestLists = {
  path: 'testLists',
  method: 'get',
  options: {access: 'paid'},
  requestDataSchema: z.object({}),
  responseDataSchema: TestListSchema.and(z.object(WithIdSchema)).array(),
} satisfies ApiDefinition;

export const GetTestList = {
  path: 'testList',
  method: 'get',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    listId: ObjectIdSchema,
  }),
  responseDataSchema: TestListSchema.and(z.object(WithIdSchema)),
} satisfies ApiDefinition;

export const GetTestListReferences = {
  path: 'testListReferences',
  method: 'get',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    testListId: ObjectIdSchema,
  }),
  responseDataSchema: z.object({
    agents: AgentSchema.pick({id: true, label: true}).array(),
    markets: MarketSchema.pick({id: true, label: true}).array(),
  }),
} satisfies ApiDefinition;

export const DeleteTestList = {
  path: 'deleteTestList',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    testListId: ObjectIdSchema,
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const ImportTestList = {
  path: 'importTestList',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    label: z.preprocess(
      (v) => String(v).trim(),
      z
        .string()
        .regex(TestListName.pattern)
        .min(TestListName.minLength)
        .max(TestListName.maxLength)
    ),
    domains: z.string().array().max(MaxTestListAccounts),
  }),
  responseDataSchema: z.object({
    testList: TestListSchema.and(z.object(WithIdSchema)),
  }),
} satisfies ApiDefinition;
